import React, { Component } from "react";
import Wrp from '../../../../../../../hoc/Wrp/Wrp';
// import {Card,CardBody} from '../../../../../../../hoc/Card';
import BootstrapRow from '../../../../../../../hoc/BootstrapRow';
import BootstrapColumn from '../../../../../../../hoc/BootstrapColumn';
// import Datetime from 'react-datetime';
import moment from 'moment';
import 'react-datetime/css/react-datetime.css';
// import {getDateFormat} from '../../../../../../../Utils/UserFunctions';
import {checkIsActivityTypeFieldIsExists} from '../../../../../../../Containers/LayoutContainer/LayoutCommonFunction';
import OnDateOption from './OnDateOption';
import FormInputFields from '../../../../../../../Components/FormInputFields';
import OnCustomOption from './OnCustomOption';
import ToolTipWrapper from '../../../../../../../hoc/Wrp/ToolTipWrapper';
// import reminder from "../../../../../../Icons/IconsList/IconReminder";
import EmailOptions from './EmailOptions';
import { isSet } from "../../../../../../../Utils/CommonFunctions";
import ShowNotification from "./ShowNotification";

class ReminderOption extends Component {

  constructor(props) {
    super(props);
    this.state = {
      dt: moment(),
      setDt: moment(),
      otherOptionMsg:'',
    }
  }
  render() {
    const  {
    //   type,
    //   item,
    //   className,
    //   validationForms,
    displayText,
    closeReminderPopup,
    popupModeChangeHandler,
    reminderJson,
    // reminderChangeHandler,
    displayReminder,
    remindApplyButton
    } = this.props;

    const reqObj = {
      ...this.props
    };
    let defaultMultiSelect = [];
    // console.log(Array.isArray(display_text),reminderJson.display_text);
    let display_text = (Array.isArray(reminderJson.display_text)===false)?reminderJson.display_text.split(','):reminderJson.display_text;
      isSet(displayText,[]).map((item)=>{
        if(display_text.indexOf(item.fieldId)!==-1){
          defaultMultiSelect.push(item);
        }
      });
    
    const multiSelect = {
      type:'Multiselect',
      label:{
        text:"Display fields",
        className:"",
      },
      attributes:{
        // name:'fields'
      },
      validation:{
        required:true,
        isValid:false
      },
      value:defaultMultiSelect,
      changeHandler:this.multiSelectOnChangeHandler,
      options:(displayText!==undefined)?displayText.map((item)=>{
        item.label = item.label;
        item.value = item.fieldId;
        return item;
      }):[]
    }
    const {remind_alert} =   reminderJson;
    // console.log(reminderJson);
    return (
      // <Card className={`card reminderBasic`} attributes={{style:{position:'relative'}}}>
      //   <CardBody>
      <>
          <BootstrapRow>
            <BootstrapColumn column={`col-lg-8  col-12`}>
              <ShowNotification 
                {...reqObj} />
            </BootstrapColumn>
            <BootstrapColumn column={`col-12`}>
              <ReminderTopOption 
                {...reqObj}
                otherOptionMsg={this.state.otherOptionMsg}
                reminderOptionChangeHanlder={this.reminderOptionChangeHanlder}
                OnDateOption={OnDateOption}
                OnCustomOption={OnCustomOption} />
            </BootstrapColumn>            
          </BootstrapRow>
          <div className="row mb-2">
            <BootstrapColumn column={`col-12`}>
              <label className="text-truncate mb-0">Display fields</label>
              <FormInputFields {...multiSelect} />
            </BootstrapColumn>
          </div>
          {(remind_alert===0 || remind_alert===2)?
            <EmailOptions {...this.props}/>
          :''}
          <BootstrapRow>
            <BootstrapColumn column="col-12">
              <RepeatReminder 
                {...reqObj}
                doesNotRepeatChangeHandler={this.doesNotRepeatChangeHandler}
                applyRepeatHandler={this.applyRepeatHandler} />
                <label className="badge badge-warning" onClick={e=>popupModeChangeHandler('REPEAT')}> 
                    {(reminderJson.repeat_type===4)?displayReminder.repeat:''} 
              </label>	
            </BootstrapColumn>
				  </BootstrapRow>
        {/* </CardBody> */}
        {/* <div className="d-flex border-top p-2 pb-0" style={{justifyContent:'space-between'}}>
          <button type="button" className="btn border-default btn-border cursor-pointer" 
            onClick={closeReminderPopup.bind(this,reminderJson)}> 
            {`Cancel`}
          </button>
          <button type="button" disabled={remindApplyButton} className="btn primary_bg btn" onClick={this.props.applyReminderHandler}>{`Apply`}</button>
	      </div> */}
        <ToolTipWrapper />
        </>
      // </Card>   
    );
  }
  multiSelectOnChangeHandler = (value)=>{
    // console.log(value);
    let selectedValue = [];
    if(value!==null){
      value.map((item)=>{
        selectedValue.push(item.fieldId);
      })
    }
   
    this.props.actionChangeHandler(value,'display_text',selectedValue);
    // console.log(value);
  }
  doesNotRepeatChangeHandler = (e,value)=>{
    const {reminderJson,updateReminderComponentObject,clearRepeatOptions} = this.props;
    reminderJson.repeat_type  = 0;
    reminderJson.repeat_frequency = 0;//"Daily, Weekly, Monthly, Yearly",
    reminderJson.repeat_every =  1;//"1-n",
    reminderJson.repeat_weekday = 1;//"0-6",
    reminderJson.repeat_dom = '';//"1-31",
    updateReminderComponentObject(reminderJson);
    clearRepeatOptions();
  }
  
  getRemindDateFromLayout = (label)=>{
    const {updateReminderComponentObject,reminderJson,fieldGroups} = this.props; 
    let selectedValue = '';
     fieldGroups.map((section)=>{
       section.data.map((field)=>{
        if(field.label.blocks[0].text.toLowerCase()===label){
          console.log(field);
          selectedValue = field.selectedValue; 
          selectedValue = (selectedValue!=='' && selectedValue!=null)?moment(selectedValue,'YYYY-MM-DD HH:mm:ss.S',true).format('YYYY-MM-DD'):'';
          // console.log(selectedValue);
          if(selectedValue!=='' && selectedValue!==null){
            reminderJson.remindOption  = 'CUSTOM';
            reminderJson.remind_period  = 1;
            reminderJson.remind_date  = selectedValue;
            reminderJson.remind_on    = 1;
          }
          updateReminderComponentObject(reminderJson);
        }
      })
    })
    return selectedValue;
  }
  // componentDidMount = ()=>{
  //   const {reminderJson} = this.props; 
  //   this.reminderOptionChangeHanlder({},reminderJson.remindOption);
  // }
  //REMINDER HANDLER WHEN CLICK ON TOP RADIO OPTION
  reminderOptionChangeHanlder = (e,value)=>{
    const {updateReminderComponentObject,reminderJson,fieldGroups} = this.props; 
    this.setState({otherOptionMsg:''});
    if(value==='DAY'){ 
      reminderJson.remind_date  = moment().format('YYYY-MM-DD'); 
      reminderJson.remind_on    = 0;
      reminderJson.remindOption = value;
      updateReminderComponentObject(reminderJson);
    }else{ 
      const activityField = checkIsActivityTypeFieldIsExists(fieldGroups,true);
      // console.log(activityField);
      let otherMsg = 'To Date';
      if(activityField.isExist===true){
        activityField.item.options.map((item)=>{
          if(activityField.item.selectedValue===item.id && item.value.toLowerCase()==='tasks'){
            // console.log('tasks'+this.getRemindDateFromLayout(fieldGroups,'due date'));
            reminderJson.remind_date = this.getRemindDateFromLayout('due date');
            otherMsg = 'Due date';
          }else if (activityField.item.selectedValue===item.id && item.value.toLowerCase()==='calls'){
            reminderJson.remind_date = this.getRemindDateFromLayout('call start time');
            otherMsg = 'Call start time';
          }else if (activityField.item.selectedValue===item.id && item.value.toLowerCase()==='meetings'){
            reminderJson.remind_date = this.getRemindDateFromLayout('to');
            otherMsg = 'To date';
          }
        })
        if(reminderJson.remind_date===''){
          this.setState({otherOptionMsg:otherMsg+' must be required for other options'})
          setTimeout(() => {
            this.setState({otherOptionMsg:''})
          }, 1500);
        }
      }else {
        reminderJson.remind_date  = moment().format('YYYY-MM-DD'); 
        reminderJson.remind_on    = 0;
        reminderJson.remindOption = value;
        updateReminderComponentObject(reminderJson);
      }
    }

    
  }
}

ReminderOption.defaultProps = {
}

const ReminderTopOption = (props)=>{
  const {reminderJson,reminderOptionChangeHanlder} = props;
  // console.log(reminderJson.remindOption);
  return(
    <Wrp>
      <div className="form-group mb-2">
				<label className="form-radio-label">
          <input 
            style={{"top":"0px"}}
            className="form-radio-input" 
            type="radio" name="optionsRadios" 
            onChange={e=>reminderOptionChangeHanlder(e,'DAY')}
            checked={(reminderJson.remindOption==='DAY')?true:false} />
					<span className="form-radio-sign ml-1 pl-1">
            {`By Date`}
          </span> 
				</label>
        {/* {(reminderJson.remind_date!=='' && reminderJson.remind_date!==null)? */}
          
          <label className="form-radio-label ml-3">
          <input 
            style={{"top":"0px"}}
            className="form-radio-input" 
            type="radio" 
            name="optionsRadios" 
            onChange={e=>reminderOptionChangeHanlder(e,'CUSTOM')}
            checked={(reminderJson.remindOption==='CUSTOM')?true:false} />
					<span className="form-radio-sign pl-1">
            {`Other Options`} 
          </span>
				</label>
        <div className="text-danger m-1">{props.otherOptionMsg}</div>
        {/* :''} */}
        
			</div>
      {(reminderJson.remindOption==='DAY')?
        <props.OnDateOption {...props} />
      :
        <props.OnCustomOption {...props} />
      }
    </Wrp>
  )
}

// 
// const ShowNotification = (props)=>{
//   const {reminderJson,actionChangeHandler} = props;
//   return(
//     <Wrp>
//       <div className="form-group">
// 				<label className="d-blockdd"> Show Notification : </label> 
// 				<div className="selectgroup display-blockd pl-2">
// 					<label className="selectgroup-item">
//             <input 
//               type="radio" 
//               name="icon-input" 
//               className="selectgroup-input"
//               onChange={e=>actionChangeHandler(e,'remind_alert',0)}
//               checked={(reminderJson.remind_alert===0)?true:false}
//              />
// 						<span className="selectgroup-button selectgroup-button-icon"> 
//               {`Email`}  
//             </span>
// 					</label>
// 					<label className="selectgroup-item">
//             <input 
//               type="radio" 
//               name="icon-input" 
//               className="selectgroup-input"
//               onChange={e=>actionChangeHandler(e,'remind_alert',1)}
//               checked={(reminderJson.remind_alert===1)?true:false} />
// 						<span className="selectgroup-button selectgroup-button-icon"> 
//               {`Popup`} 
//             </span>
// 					</label>
// 					<label className="selectgroup-item">
//             <input 
//               type="radio" 
//               name="icon-input" 
//               className="selectgroup-input"
//               onChange={e=>actionChangeHandler(e,'remind_alert',2)}
//               checked={(reminderJson.remind_alert===2)?true:false} />
// 					  <span className="selectgroup-button selectgroup-button-icon"> 
//               {`Both`}
//             </span>
// 					</label>
// 				</div>
// 			</div>
//     </Wrp>
//   )
// }


const RepeatReminder =(props)=>{
  const {actionChangeHandler,reminderJson,popupModeChangeHandler,doesNotRepeatChangeHandler} = props;
  return(
    <Wrp>
      <div className={`form-group mb-0`}>
				<label className="">{`Repeat Reminder`}</label> 
				<div className="selectgroup display-block ml-2">
          <a data-tip={(reminderJson.remind_date==='' || reminderJson.remind_date===null)?"select a due/to date for repeat":''}>
					<label className="selectgroup-item">
            <input 
              type="radio" 
              name="icon-input2" 
              className="selectgroup-input" 
              onChange={e=>doesNotRepeatChangeHandler(e,'')} 
              onClick={e=>popupModeChangeHandler('REMINDER')}
              disabled={(reminderJson.remind_date==='' || reminderJson.remind_date===null)?true:false}
              
              checked={(reminderJson.repeat_type!==4)?true:false} />
						<span className="selectgroup-button selectgroup-button-icon">
              {`Doesn't Repeat`} 
            </span>
					</label> 
					<label className="selectgroup-item">
            <input 
              type="radio" 
              name="icon-input2"  
              className="selectgroup-input" 
              id="repeatCustom"
              disabled={(reminderJson.remind_date==='' || reminderJson.remind_date===null)?true:false} 
              onChange={e=>actionChangeHandler(e,'repeat_type',4)} 
              onClick={e=>popupModeChangeHandler('REPEAT')}
              checked={(reminderJson.repeat_type===4)?true:false} 
            />
						<span className="selectgroup-button selectgroup-button-icon">
              {`Custom`} 
            </span>
					</label>
          </a>
				</div>
			</div>
    </Wrp>
  )
}
export default ReminderOption;
